import cx from 'clsx'
import React, { DetailedHTMLProps, FC, HTMLAttributes } from 'react'

import cn from '../styles.module.scss'

export interface IBlockProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  bgColor?: 'grey' | 'white'
  align?: 'center' | 'start' | 'end' | 'between'
  direction?: 'row' | 'col'
}

const Block: FC<IBlockProps> = ({
  bgColor,
  align,
  direction,
  children,
  className,
  ...rest
}) => {
  const classes = cx(
    bgColor && cn[bgColor],
    bgColor && cn[bgColor],
    align && cn[align],
    direction && cn[direction],
    className,
  )

  return (
    <div {...rest} className={classes}>
      {children}
    </div>
  )
}

export default Block
